import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './DesktopNavBarCategory.css';
import * as util from '../../utils/urlParams';

export class DesktopNavBarCategory extends Component {
  handleClick = (e, subCategory = undefined) => {
    const { isSelected, selectedSubCategory } = this.props;

    if (isSelected && !subCategory) {
      e.preventDefault();
      return null;
    }

    if (subCategory && subCategory.url === selectedSubCategory.url) {
      e.preventDefault();
      return null;
    }
  };

  renderArrow() {
    const { url } = this.props.category;
    if (['/help', '/login'].indexOf(url) !== -1) {
      return null;
    }

    const { isSelected = false } = this.props;
    let arrowClasses = 'nav-bar-category__arrw';
    arrowClasses += isSelected ? ' nav-bar-category__arrw--dwn' : ' nav-bar-category__arrw--lft';

    return <span className={arrowClasses} />;
  }

  renderSubCategories() {
    const { subCategories = [], selectedSubCategory = { name: '' }, category = { name: '', id: '' } } = this.props;
    if (subCategories.length === 0) {
      return null;
    }

    return (
      <ul className="nav-bar__subcategories">
        {subCategories.map((subCategory) => {
          const isSelected = selectedSubCategory.name === subCategory.name;
          const subcategoryUrlWithSearch = subCategory.url + this.appendSearch(category.name, subCategory.id);

          let subCategoryClasses = 'nav-bar-category-subcategory__link';
          subCategoryClasses += isSelected ? ' nav-bar-category-subcategory__link--selected' : '';
          return (
            <li className="nav-bar-category-subcategory" key={subCategory.id}>
              <Link
                className={subCategoryClasses}
                id={`${category.id}-${subCategory.name.toLowerCase()}`}
                to={subcategoryUrlWithSearch}
                onClick={(e) => this.handleClick(e, subCategory)}
              >
                {subCategory.name}
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }

  appendSearch(categoryName, subCategoryId = '') {
    const {
      electricalGraphDateRange,
      gasGraphDateRange,
      diagnosticsGraphDateRange,
      thermostatGraphDateRange,
      category,
    } = this.props;

    let graphDateRange;

    switch (categoryName) {
      // set the graphDateRange to the corresponding one based on category
      case 'Electrical Usage':
        const electricalDateFromSession = window.sessionStorage.getItem('electricalGraphDateRange');
        graphDateRange = electricalDateFromSession ? JSON.parse(electricalDateFromSession) : electricalGraphDateRange;
        break;
      case 'Gas Usage':
        const gasDateFromSession = window.sessionStorage.getItem('gasGraphDateRange');
        graphDateRange = gasDateFromSession ? JSON.parse(gasDateFromSession) : gasGraphDateRange;
        break;
      case 'Diagnostics':
        const diagnosticsDateFromSession = window.sessionStorage.getItem('diagnosticsGraphDateRange');
        graphDateRange = diagnosticsDateFromSession
          ? JSON.parse(diagnosticsDateFromSession)
          : diagnosticsGraphDateRange;
        break;
      case 'Thermostats':
        const thermostatDateFromSession = window.sessionStorage.getItem('thermostatGraphDateRange');
        graphDateRange = thermostatDateFromSession ? JSON.parse(thermostatDateFromSession) : thermostatGraphDateRange;
        break;
      default:
        graphDateRange = {};
        break;
    }

    let search = '';
    if (['Settings', 'Help', 'Account', 'Alerts'].indexOf(categoryName) === -1 && categoryName !== 'settings') {
      if (category.id === 'diagnostics') {
        const customDataPoints = JSON.parse(window.sessionStorage.getItem('customDataPoints')) || {};

        const customDataPointForSubCategory = customDataPoints[subCategoryId] || [];

        search = util.addSearchParams(graphDateRange, customDataPointForSubCategory);
      } else {
        search = util.addSearchParams(graphDateRange);
      }

      if (search) {
        return `?${search}`;
      }
    }

    return search;
  }

  render() {
    const {
      isSelected = false,
      subCategories = [],
      category: { name, image, url, id },
    } = this.props;

    // if subcategories exist, append subcategory url, otherwise go to root url
    let targetUrl;
    if (subCategories.length === 0) {
      targetUrl = url;
    } else {
      targetUrl = subCategories[0].url;
      targetUrl += this.appendSearch(name, subCategories[0].name);
    }

    let imgSrc;
    try {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      imgSrc = require(`./assets/${image}.png`);
    } catch (e) {
      imgSrc = '';
    }

    let navBarCategoryClasses = 'nav-bar-category';
    navBarCategoryClasses += isSelected ? ' nav-bar-category--selected' : '';

    return (
      <li className={navBarCategoryClasses}>
        <Link id={id} to={targetUrl} className="nav-bar-category__link">
          <div className="nav-bar-category__title-wrapper">
            {id === 'settings' ? (
              <div className="nav-bar-category__icon">
                <FontAwesomeIcon icon={faCog} size="lg" color="#ffffff" />
              </div>
            ) : null}
            {id !== 'settings' ? <img className="nav-bar-category__icon" src={imgSrc} alt="" /> : null}
            <div className="nav-bar-category__title">{name}</div>
          </div>
          {this.renderArrow()}
        </Link>
        {isSelected ? this.renderSubCategories() : null}
      </li>
    );
  }
}

DesktopNavBarCategory.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    sub_categories: PropTypes.arrayOf(
      PropTypes.shape({
        api_location: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  selectedSubCategory: PropTypes.shape({
    api_location: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
};

DesktopNavBarCategory.defaultProps = {
  selectedSubCategory: undefined,
  subCategories: undefined,
};

export function mapStateToProps(state) {
  return {
    electricalGraphDateRange: state.utilityReducer.electricalGraphDateRange,
    gasGraphDateRange: state.utilityReducer.gasGraphDateRange,
    diagnosticsGraphDateRange: state.diagnosticsReducer.graphDateRange,
    thermostatGraphDateRange: state.suiteReducer.graphDateRange,
  };
}

const ConnectedDesktopNavBarCategory = connect(mapStateToProps)(DesktopNavBarCategory);
export { ConnectedDesktopNavBarCategory };
